import axios from 'axios'
// import qs from 'qs'


let timestamp1 = Date.parse(new Date() + '') / 1000
// 时间戳
// 公共请求参数
export const commonParams = {
  '_t': timestamp1,
  column: 'createTime',
  order: 'desc',
  pageNo: 1,
  pageSize: 100,
  superQueryMatchType: 'and'
}

let baseUrl = '/api'
// let baseUrl = 'https://tools.heliumflash.cn/api'
axios.defaults.withCredentials = true

// 创建 axios 实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
  baseURL: baseUrl, // url = base url + request url
  timeout: 6000000, // request timeout
  // transformRequest: (data) => qs.stringify(data) // 统一格式data数据
})

/**
 * 请求拦截器
 * 客户端发送请求 -> [请求拦截器] -> 服务器
 * Token校验(JWT)
 */
service.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // config.headers['Accept'] = 'application/json'
    // config.headers['Request-From'] = 'mobile'
    let token = localStorage.getItem('oauthToken') || sessionStorage.getItem('loginToken') || null
    if (token) {
      // 如果token不为null，否则传token给后台
      config.headers['oauthToken'] = token
      config.headers['Token'] = token
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

/**
 * 响应拦截器
 */
service.interceptors.response.use(
  (response) => {
    const res = response.data
    //届时根据后端返回success或者code值判断
    if (res.success === true) {
      return res
    } else {
      return res
    }
  },
  (error) => {
    console.log(error)

    if (error.response && error.response.status === 401) {
      // 401 清除token信息并跳转到登录页面
      localStorage.removeItem('oauthToken')
      sessionStorage.removeItem('loginToken')
      location.href = '/#/login';
    }

    return Promise.reject(error)
  }
)

export default service
